import { h, Component } from 'preact';
import Store from 'store/store';
import { accessNested, sortObjectByOrder, joinClasses } from 'utils/utils';
import Link from 'components/bolt/link/link';
import * as webp from 'utils/bolt/webp';
import s from 'components/bolt/footer/sonyFooter.sss';

export default class SonyFooter extends Component {
	constructor(props) {
		super(props);

		this.state = {
			expanded: true
		};

		this.toggleFooterExpanded = this.toggleFooterExpanded.bind(this);
		this.getFallbackFormat = this.getFallbackFormat.bind(this);
	}

	componentDidMount() {
		const expandDuration = accessNested(this.props, 'data.expandDuration', 6);

		this.timeout = window.setTimeout(() => {
			this.toggleFooterExpanded(false);
		}, expandDuration * 1000);
		this.updateCoveredScreenSize();
	}

	componentDidUpdate() {
		this.updateCoveredScreenSize();
	}

	updateCoveredScreenSize() {
		if (this.props.showtimes) {
			return;
		}
		const store = Store.get();
		let isMobileOrTablet = store?.client?.deviceSize === 'mobile' || store?.client?.deviceSize === 'tablet';
		let coveredScreenSize = isMobileOrTablet && this.$container ? this.$container.offsetHeight : 0;
		if (coveredScreenSize !== store.footer.coveredScreenSize) {
			store.footer.set({ coveredScreenSize });
		}
	}

	componentWillUnmount() {
		window.clearTimeout(this.timeout);
	}

	toggleFooterExpanded(expanded) {
		if (typeof expanded === 'undefined') {
			expanded = !this.state.expanded;
		}

		this.setState({ expanded });
	}

	onFooterLinkClick(linkCopy) {
		Store.emit('CUSTOM_EVENT', { action: 'sonyFooterClick', label: linkCopy, category: 'footer' });
	}

	getFallbackFormat() {
		return accessNested(this.props, 'appData.footer.alternativeImageFormat', 'png');
	}

	renderLegalLogos() {
		const logos = accessNested(this.props, 'data.logos.src', '');
		const alt = accessNested(this.props, 'data.logos.alt', '');

		if (logos) {
			const fallbackFormat = this.getFallbackFormat();
			return (
				<webp.Picture
					class={s.logos}
					src={logos}
					alt={this.props.copy.accessibilityCopy[alt] || alt}
					fallbackFormat={fallbackFormat}
				/>
			);
		}
	}

	renderExpandedFooter(links, copyrights) {
		const { expanded } = this.state;
		const closeAriaLabel = accessNested(this.props, 'copy.accessibilityCopy.$SONY_FOOTER_CLOSE_BTN_ARIA', '');

		return (
			<div class={joinClasses(s.expandedFooter, expanded && s.open)}>
				<button class={s.close} onClick={() => this.toggleFooterExpanded(false)} ariaLabel={closeAriaLabel} />
				<div class={s.content}>
					{this.renderLegalLogos()}
					<div class={s.links}>
						{links.map(link => {
							const showPrivacyChoicesLogo = link.showPrivacyChoicesLogo;

							if (link.link?.match(/OneTrust\.ToggleInfoDisplay/)) {
								return (
									<div class={s.link} onClick={() => window.OneTrust?.ToggleInfoDisplay()}>
										{link.label}
									</div>
								);
							}
							if (link.openCookieConsentTool) {
								return (
									<div class={s.expandedLink} onClick={() => window.evidon.notice.showPreferencesDialog()}>
										{link.label}
									</div>
								);
							}
							return (
								<Link href={link.link} class={joinClasses(s.expandedLink, showPrivacyChoicesLogo && s.doNotSellLink)} target="_blank" onClick={() => this.onFooterLinkClick(link.label)}>
									{link.label}
									{showPrivacyChoicesLogo && this.renderDoNotSellLogo()}
								</Link>
							);
						})}
					</div>
					<div class={s.links}>
						{copyrights.map(copyright => {
							return (
								<Link href={copyright.link} class={joinClasses(s.expandedLink, s.copyright)} target="_blank" onClick={() => this.onFooterLinkClick(copyright.label)}>
									{copyright.label}
								</Link>
							);
						})}
					</div>
				</div>
			</div>
		);
	}

	renderDoNotSellLogo() {
		const { appData } = Store.get();
		const imageRoot = appData.urls.roots.sharedImages;

		return (
			<img class={s.doNotSellLogo} src={imageRoot + '/Your_Privacy_Choices.png'} alt="Your privacy choices logo" />
		);
	}

	render({ data, showtimes }) {
		const links = sortObjectByOrder(data.links);
		const filteredLinks = links.filter(link => !link.expandedFooterOnly);
		const copyrights = sortObjectByOrder(data.copyrights);

		if (showtimes) {
			return <div />;
		}

		return (
			<div
				class={s.wrapper}
			>
				{this.renderExpandedFooter(links, copyrights)}
				<div class={s.container} ref={e => this.$container = e}>
					{filteredLinks.map(link => {
						const showPrivacyChoicesLogo = link.showPrivacyChoicesLogo;

						if (link.link?.match(/OneTrust\.ToggleInfoDisplay/)) {
							return (
								<div class={s.link} onClick={() => window.OneTrust?.ToggleInfoDisplay()}>
									{link.label}
								</div>
							);
						}
						if (link.openCookieConsentTool) {
							return (
								<div class={s.link} onClick={() => window.evidon.notice.showPreferencesDialog()}>
									{link.label}
								</div>
							);
						}
						return (
							<Link class={joinClasses(s.link, showPrivacyChoicesLogo && s.doNotSellLink)} href={link.link} target="_blank" onClick={() => this.onFooterLinkClick(link.label)}>
								{link.label}
								{showPrivacyChoicesLogo && this.renderDoNotSellLogo()}
							</Link>
						);
					})}
					<div id="sonyCreditButton" class={s.link} onClick={() => this.toggleFooterExpanded(true)}>Credits</div>
				</div>
			</div>
		);
	}
}
